import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=1c8bacf5&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=1c8bacf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bacf5",
  null
  
)

export default component.exports